import React from 'react'
import { Button, Flex, Text, Box } from 'pcln-design-system'
import Banner from '@pcln/banners'
import { StyledDiscount } from './ReshopHeader.styles'

const ReshopHeader = ({ airlineName, changeFee, creditAvailable, modifyNow }) => {
  if (airlineName === '' || creditAvailable == null) {
    return null
  }
  const viewAllFlightsWithoutCredits = () => {
    const urlWithoutOfferToken = window.location.href.replace(/offer-token=[^&]*/, '')
    window.open(urlWithoutOfferToken, '_blank')
  }
  return (
    <Flex mx={[2, 2, 2, 2, 0]} flexDirection='column'>
      {modifyNow ? null : (
        <Flex>
          <Button onClick={viewAllFlightsWithoutCredits} ml='auto' color='primary' variation='link'>
            <Text bold fontSize={0}>
              {'View all flights without your credit >'}
            </Text>
          </Button>
        </Flex>
      )}
      <Box my={3}>
        {modifyNow ? null : (
          <Banner
            bgColor='highlight.light'
            iconLeft={<StyledDiscount color='success.dark' size={['36px', '40px']} ml={[2, 3]} mr={[0, 2]} />}
            heading={
              <Text fontSize={2} color='success.dark' bold>
                Your ${creditAvailable?.toFixed(2)} credit with {airlineName} has been applied to all flights
                below!
              </Text>
            }
            text={
              changeFee > 0 ? (
                <Text color='text.base' mt={1} fontSize={0}>
                  {airlineName} charges a ${changeFee} change fee for redemption of credits. This fee is
                  reflected in the prices shown.
                </Text>
              ) : undefined
            }
          />
        )}
      </Box>
    </Flex>
  )
}

export default ReshopHeader
